const DEFAULT_ACCESS_KEY = "access_token";
const DEFAULT_REFRESH_KEY = "refresh_token";

function safeGetItem(key: string): string | null {
  if (typeof window === "undefined" || !window.localStorage) return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSetItem(key: string, value: string): void {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // ignore
  }
}

function safeRemoveItem(key: string): void {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export interface LocalStorageAuthOptions {
  accessTokenKey?: string;
  refreshTokenKey?: string;
}

export interface LocalStorageAuth {
  getToken: () => string | null;
  setToken: (token: string) => void;
  getRefreshToken: () => string | null;
  setRefreshToken: (token: string) => void;
  clearAuth: () => void;
}

export function createLocalStorageAuth(
  options: LocalStorageAuthOptions = {},
): LocalStorageAuth {
  const accessKey = options.accessTokenKey ?? DEFAULT_ACCESS_KEY;
  const refreshKey = options.refreshTokenKey ?? DEFAULT_REFRESH_KEY;

  return {
    getToken: () => safeGetItem(accessKey),
    setToken: (token: string) => safeSetItem(accessKey, token),
    getRefreshToken: () => safeGetItem(refreshKey),
    setRefreshToken: (token: string) => safeSetItem(refreshKey, token),
    clearAuth: () => {
      safeRemoveItem(accessKey);
      safeRemoveItem(refreshKey);
    },
  };
}

export const localStorageAuth: LocalStorageAuth = createLocalStorageAuth();

/** 默认实例方法，便于外部直接按名导入使用 */
export const getToken = localStorageAuth.getToken;
export const setToken = localStorageAuth.setToken;
export const getRefreshToken = localStorageAuth.getRefreshToken;
export const setRefreshToken = localStorageAuth.setRefreshToken;
export const clearAuth = localStorageAuth.clearAuth;
